module.exports = __webpack_public_path__ + "img/dashboard_black.e318c183.svg";